import { contentConstants } from '../_constants/content.constants'

const initialState = {
  isLoading: false,
  data: null,
  message: null,
}

export function content(state = { ...initialState }, action) {

  switch (action.type) {
  case contentConstants.GET_REQUEST:
    return {
      ...state,
      isLoading: true,
      message: null
    }
  case contentConstants.GET_SUCCESS:
    return {
      ...state,
      data: action.content.data,
      isLoading: false
    }
  case contentConstants.GET_ERROR:
    return {
      ...state,
      data: null,
      isLoading: false
    }
  case contentConstants.PUT_REQUEST:
    return {
      ...state,
      isLoading: true,
      message: null
    }
  case contentConstants.PUT_SUCCESS:
    return {
      ...state,
      data: action.content.data,
      message: action.content.message,
      isLoading: false
    }
  case contentConstants.PUT_ERROR:
    return {
      ...state,
      isLoading: false
    }
  default:
    return state
  }

}
